export default __webpack_public_path__ + "static/Garage-Cleanout-e73699a7afad35e4d5a653b254471dd5.jpg";